'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import DynamicLogo from '@components/DynamicLogo';
import DynamicHideBlock from '@components/DynamicHideBlock';
import cn from './style.module.scss';
export default function OgamiFooter(props: MarketingPageComponentProps) {
  const footerSection = props?.locale?.section?.find(
    (section: any) => section.type === 'footer' && section.enabled
  );
  if (!footerSection) return null;
  return (
    <Stack component="footer" className={cn.ogamiFooterWrapper}>
      <Box className={cn.ogamiFooterInner}>
        <Box className={cn.ogamiFooterBlock}>
          <Box className={cn.ogamiFooterDevoloped}>
            <ParallaxText
              variant="p"
              animationType="slideInBottom"
              animationDuration={500}
            >
              {ReactHtmlParser(footerSection?.ogamiFooterDevelopedBy)}
            </ParallaxText>
          </Box>
          <Box className={cn.ogamiFooterSodic}>
            <DynamicHideBlock data={footerSection?.ogamiFooterSodicLogo}>
              <Box component="picture" className={cn.ogamiFooterElement}>
                <DynamicLogo
                  logoImage={footerSection?.ogamiFooterSodicLogo}
                  alt={'Ogami Logo'}
                />
              </Box>
            </DynamicHideBlock>
          </Box>
          <Box className={cn.ogamiFooterAldar}>
            <ParallaxText
              variant="p"
              animationType="slideInBottom"
              animationDuration={500}
            >
              {ReactHtmlParser(footerSection?.ogamiFooterSodicAldar)}
            </ParallaxText>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
